import { Button } from "primereact/button";

const ErrorMessage = ({ error, message = "An unexpected error occurred.", onRetry, retryLabel = "Retry" }) => {
	if (error) console.error(error);
	return (
		<div className="flex gap-small aItems-center">
			<i className="pi pi-exclamation-circle fontColour-error" />
			<span className="fontColour-error">{message}</span>
			{onRetry && <Button type="button" label={retryLabel} className="p-button-text" onClick={onRetry} />}
		</div>
	);
};

export default ErrorMessage;
